module.exports = __webpack_public_path__ + "FIAT-logo.png";